"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clickPropsSDKFactory = void 0;
const corvidEvents_1 = require("../corvidEvents");
const clickPropsSDKFactory = api => ({
    onClick: handler => (0, corvidEvents_1.registerCorvidMouseEvent)('onClick', api, handler),
    onDblClick: handler => (0, corvidEvents_1.registerCorvidMouseEvent)('onDblClick', api, handler),
});
exports.clickPropsSDKFactory = clickPropsSDKFactory;
//# sourceMappingURL=clickPropsSDKFactory.js.map